import ColoredMarker from "./ColoredMarker";
import { IDiagnosticServiceOrdering } from "../../modules/serviceOrdering/interfaces";

const ServiceTypeDiagComponent = ({
  item,
}: {
  item: IDiagnosticServiceOrdering;
}) => {
  return (
    <>
      {item.types?.map((type, index) =>
        type.isChecked ? (
          <ColoredMarker className={"m-1"} key={index} color={"#000D5B"}>
            {type.name}
          </ColoredMarker>
        ) : null,
      )}
    </>
  );
};

export default ServiceTypeDiagComponent;
